import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Textarea } from '../ui/textarea';
import { Plus } from 'lucide-react';
import { leaveTypes } from '../../lib/leaves';

export const LeaveFormDialog = ({
  open,
  onOpenChange,
  workers,
  formData,
  setFormData,
  onSubmit,
  isSubmitting
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button
        data-testid="add-leave-btn"
        className="h-12 px-6 bg-[#2E4632] hover:bg-[#1F3122] text-white font-semibold"
      >
        <Plus className="w-5 h-5 mr-2" />
        Add Leave
      </Button>
    </DialogTrigger>
    <DialogContent className="sm:max-w-md max-h-[92vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-[#1C1C1E]" style={{ fontFamily: 'Manrope, sans-serif' }}>
          New Leave Request
        </DialogTitle>
        <DialogDescription className="text-[#5C5C5C]">
          Record a worker's leave dates so attendance and wages stay accurate.
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label>Worker *</Label>
          <Select
            value={formData.worker_id}
            onValueChange={(value) => setFormData({ ...formData, worker_id: value })}
          >
            <SelectTrigger data-testid="leave-worker-select" className="h-12 border-[#D1D1CD]">
              <SelectValue placeholder="Select worker" />
            </SelectTrigger>
            <SelectContent>
              {workers.map(worker => (
                <SelectItem key={worker.id} value={worker.id}>
                  {worker.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Leave Type *</Label>
          <Select
            value={formData.leave_type}
            onValueChange={(value) => setFormData({ ...formData, leave_type: value })}
          >
            <SelectTrigger data-testid="leave-type-select" className="h-12 border-[#D1D1CD]">
              <SelectValue placeholder="Select leave type" />
            </SelectTrigger>
            <SelectContent>
              {leaveTypes.map(type => (
                <SelectItem key={type.value} value={type.value}>
                  {type.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Start Date *</Label>
            <Input
              type="date"
              data-testid="leave-start-date"
              value={formData.start_date}
              onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
              className="h-12 border-[#D1D1CD]"
            />
          </div>
          <div className="space-y-2">
            <Label>End Date *</Label>
            <Input
              type="date"
              data-testid="leave-end-date"
              value={formData.end_date}
              onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
              className="h-12 border-[#D1D1CD]"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label>Reason</Label>
          <Textarea
            data-testid="leave-reason"
            value={formData.reason}
            onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
            placeholder="Optional reason for leave"
            className="border-[#D1D1CD]"
            rows={3}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1 h-12 border-[#D1D1CD]"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            data-testid="leave-submit-btn"
            disabled={isSubmitting}
            className="flex-1 h-12 bg-[#2E4632] hover:bg-[#1F3122] text-white"
          >
            {isSubmitting ? 'Creating...' : 'Create Leave'}
          </Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
